import React, { useState, useEffect } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import OnHoverTooltip from '../../tables/shared/OnHoverTooltip';
import EditItemList from './field_inputs/item_list/EditItemList';
import { createGetSuggestionsFromApiUrl } from './field_inputs/HelpMethods';
import EditSelect from './field_inputs/select/EditSelect';
import EditDate from './field_inputs/date/EditDate';
import { ACTIVITY, ADD_TITLE, BOOKED_CUSTOMER, CANCEL, CANCEL_WARNING, COMPLETED_CUSTOMER_MEETING, DATE_PLACEHOLDER, FILES, ITEM_ACTIVITIES, ITEM_ACTIVITY, ITEM_FILES, ITEM_NOTES, NOTE_INPUT, NOTES, SAVE, UPLOAD, YEARLY_INDEX_ADJUSTMENT } from "../../../i18n/keyConstants";
import { useTranslation } from 'react-i18next';

export const ActivityPanel = ({
    activeContent,
    activeItem,
    setActiveContent,
    dealAlternatives = [],
    PostActivity,
    PostNote,
    PostFile,
    isDealChoiceShowing = true,
    isPersonChoiceShowing = true,
}) => {
    return (
        <div className='card d-flex flex-column p-3'>
            <ContentOptions activeContent={activeContent} setActiveContent={setActiveContent} />
            <ContentActive
                activeContent={activeContent}
                activeItem={activeItem}
                dealAlternatives={dealAlternatives}
                postActivity={PostActivity}
                postNote={PostNote}
                postFile={PostFile}
                isDealChoiceShowing={isDealChoiceShowing}
                isPersonChoiceShowing={isPersonChoiceShowing}
            />
        </div>
    );
};

const ContentOptions = ({ activeContent, setActiveContent }) => {
    const { t } = useTranslation(['detailContent', 'shared']);
    return (
        <div className='d-flex flex-row w-100 mb-2 pb-2 border-bottom'>
            <ContentOption
                index={0}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
                icon='oi-comment-square'
                contentInfo={t(ITEM_NOTES)}
            />
            <ContentOption
                index={1}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
                icon='oi-calendar'
                contentInfo={t(ITEM_ACTIVITY)}
            />
            <ContentOption index={2}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
                icon='oi-file'
                contentInfo={t(ITEM_FILES)} />
        </div>
    );
};

const ContentOption = ({ contentInfo, index, activeContent, setActiveContent, icon }) => {
    return (
        <label
            type='button'
            className={`btn btn-light d-flex flex-row ${activeContent === index ? 'active' : ''}`}
            onClick={() => setActiveContent(index)}>

            <span className={'oi ' + icon} />
            <p className='pl-1 mb-0'>{contentInfo}</p>
        </label>
    );
};

const ContentActive = ({ activeContent, activeItem, dealAlternatives = [], postActivity, postNote, postFile, isDealChoiceShowing = true, isPersonChoiceShowing = true }) => {
    const [noteContent, setNoteContent] = useState('');

    const [name, setName] = useState('');
    const [activityTypeId, setActivityTypeId] = useState('BOM');
    const [date, setDate] = useState(new Date());
    const [deal, setDeal] = useState({ id: null });
    const [persons, setPersons] = useState(activeItem.contact ? [activeItem.contact] : []);
    const [activityNoteContent, setActivityNoteContent] = useState('');
    const [file, setFile] = useState(null);
    
    const { t } = useTranslation(['detailContent', 'shared']);
    const cancelNote = () => {
        if (noteContent === '') return;

        if (noteContent?.length < 20) {
            setNoteContent('');
            return;
        }

        var cancel = window.confirm(t(CANCEL_WARNING));

        if (cancel) setNoteContent('');
    };

    const dragOverHandler = (ev) => {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();
    };

    const handleFileChange = (ev) => {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();

        if (ev.dataTransfer?.files) {
            setFile(ev.dataTransfer.files[0]);
        } else {
            setFile(ev.target.files[0]);
        }
    };

    const submitActivity = (event) => {
        event.preventDefault();
        postActivity({
            name: name,
            date: date,
            activityTypeId: activityTypeId,
            persons: persons,
            dealId: deal.id ?? null,
            notes: activityNoteContent,
        });
        setName('');
        setActivityTypeId('BOM');
        setDate(new Date());
        setDeal({ id: null });
        setActivityNoteContent('');
        setPersons(activeItem.contact ? [activeItem.contact] : []);
        document.getElementById('activity-name').value = ''
    }

    return (
        <>
            {activeContent === 0 ? (
                <form className='add-note-form mb-0'>
                    <div className='d-flex flex-column bg-yellow card p-2 w-100'>
                        <EditableTextArea content={noteContent} setContent={setNoteContent} />
                    </div>
                    <div className='d-flex flex-row p-2'>
                        <div className='mr-auto'></div>
                        <div className='d-flex flex-row ml-auto'>
                            <button
                                className='btn btn-light d-flex justify-content-center align-items-center mr-1 my-auto'
                                type='button'
                                onClick={() => cancelNote()}
                                style={{ height: 30, width: 60 }}>
                                {t(CANCEL, { ns: 'shared' })}
                            </button>
                            <button
                                disabled={!noteContent.length > 0}
                                className='btn btn-success d-flex justify-content-center align-items-center ml-1 my-auto'
                                type='button'
                                onClick={() => {
                                    postNote({
                                        text: noteContent,
                                    });
                                    setNoteContent('');
                                }}
                                style={{ height: 30, width: 60 }}>
                                {t(SAVE, { ns: 'shared' })}
                            </button>
                        </div>
                    </div>
                </form>
            ) : null}
            {activeContent === 1 ? (
                <div className='d-flex flex-column card px-2 pt-2'>
                    <form id="add-activity-form" className='add-activity-form mb-0' onSubmit={submitActivity}>
                        <div>
                            <DealContentForm id='activity-name' setContent={setName} contentText={t(ADD_TITLE)} />
                            <ActivityType activityTypeId={activityTypeId} setActivityTypeId={setActivityTypeId} />
                            <SingleDateChooser date={date} setDate={setDate} />
                            {isPersonChoiceShowing ? <PersonChooser setPersons={setPersons} persons={persons} activeItem={activeItem} /> : null}
                            {isDealChoiceShowing ? <DealChooser dealAlternatives={dealAlternatives} setDeal={setDeal} deal={deal} /> : null}
                            <DealContentForm id='activity-note' contentText='Note'>
                                <div className='d-flex flex-column bg-yellow card p-2 w-100'>
                                    <EditableTextArea content={activityNoteContent} setContent={setActivityNoteContent} />
                                    <p className='mb-0 ml-auto'>{activityNoteContent.length} av 200</p>
                                </div>
                            </DealContentForm>
                        </div>
                        <div className='d-flex flex-row p-2'>
                            <div className='mr-auto'></div>
                            <div className='d-flex flex-row ml-auto'>
                                <button
                                    className='btn btn-danger d-flex justify-content-center align-items-center mr-1 my-auto'
                                    type='button'
                                    style={{ height: 30, width: 60 }}>
                                    {t(CANCEL, { ns: 'shared' })}
                                </button>
                                <button
                                    disabled={!name}
                                    className='btn btn-success d-flex justify-content-center align-items-center ml-1 my-auto'
                                    type='submit'
                                    style={{ height: 30, width: 60 }}>
                                    {t(SAVE, { ns: 'shared' })}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            ) : null}
            {activeContent === 2 ? (
                <div>
                    <div onDrop={handleFileChange} onDragOver={dragOverHandler}>
                        <label className='deal-file-input' htmlFor='deal-file'>
                            {t(NOTE_INPUT, { ns: 'detailContent' })}
                        </label>
                        <input style={{ display: 'none' }} type='file' id='deal-file' name='deal-file' onChange={handleFileChange} />
                    </div>

                    <div className='d-flex flex-row p-2'>
                        <div className='mr-auto'></div>
                        <div className='d-flex flex-row ml-auto'>
                            <span style={{ fontSize: '1rem', padding: '0.6rem', marginRight: '1rem' }} className='badge bg-light text-dark'>
                                {file?.name}
                            </span>
                            <button
                                onClick={() => {
                                    postFile(file);
                                    setFile(null);
                                }}
                                className='btn btn-success d-flex justify-content-center align-items-center ml-1 my-auto'
                                type='button'
                                disabled={!file}>
                                {t(UPLOAD, { ns: 'shared' })}
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
};

const ActivityType = ({ activityTypeId, setActivityTypeId }) => {
    return (
        <div className='d-flex flex-row mb-2 w-100'>
            <HoverActivityButton
                id='BOM'
                icon='oi-phone'
                activityTypeId={activityTypeId}
                setActivityTypeId={setActivityTypeId}
            >
            </HoverActivityButton>
            <HoverActivityButton
                id='COM'
                icon='oi-people'
                activityTypeId={activityTypeId}
                setActivityTypeId={setActivityTypeId}
            >
            </HoverActivityButton>
            <HoverActivityButton
                id='YIA'
                icon='oi-graph'
                activityTypeId={activityTypeId}
                setActivityTypeId={setActivityTypeId}
            >
            </HoverActivityButton>
        </div>
    );
};

const HoverActivityButton = ({ id, icon, activityTypeId, setActivityTypeId }) => {
    return (
        <OnHoverTooltip
            labelClassNames='d-flex margin-none'
            dataFor='show-won-button'
            tooltipType='dark'
            tooltipPlace='left'
            tooltipEffect='solid'>
            <ActivityTypeButton activityTypeId={activityTypeId} setActivityTypeId={setActivityTypeId} id={id} icon={icon} />
            <span className='d-flex my-auto'>{GetActivityTitle(id)}</span>
        </OnHoverTooltip>
    )
}

const ActivityTypeButton = ({ activityTypeId, setActivityTypeId, id, icon }) => {
    return (
        <label
            type='button'
            className={`btn btn-light d-flex align-items-center justify-content-center oi ${icon} ${activityTypeId === id ? 'active' : ''}`}
            onClick={() => setActivityTypeId(id)}
            style={{ width: 30, height: 30 }}
        />
    );
};

const SingleDateChooser = ({ date, setDate }) => {
    return (
        <div className='d-flex flex-row align-items-left justify-content-left mb-2 w-25'>
            <EditDate value={date} setValue={setDate} />
            {/* Old version just incase
             * <CustomDatePicker selectedDate={date} firstDate={new Date()} customInput={<CustomTimeInput />} onChange={(date) => setDate(date)} />*/}
        </div>
    );
};


const DealChooser = ({ dealAlternatives, setDeal, deal }) => {
    const nullOption = { id: null, name: 'Select a deal:' };
    const options = [nullOption].concat(dealAlternatives);
    const [currentDeal, setCurrentDeal] = useState(deal);

    const selectDeal = (value) => {
        setCurrentDeal(value);
        setDeal(value);
    }

    useEffect(() => {
        if (deal.id === null) {
            setCurrentDeal(nullOption);
        }
        else {
            setCurrentDeal(deal);
        }

    }, [deal]);

    return (
        <div className='w-50 mb-2'>
            <EditSelect iconName='deal' value={currentDeal} setValue={selectDeal} options={options} />
        </div>
    );
};

const PersonChooser = ({ setPersons, persons, activeItem }) => {
    return (
        <div className="w-25 mb-2">
            <EditItemList
                iconName='people'
                isClearable
                value={persons}
                setValue={(v) => {
                    setPersons(v)
                }}
                isCreationPermitted
                getSuggestions={createGetSuggestionsFromApiUrl('/api/crmPersonFront/getPersonSuggestions')}
            />
        </div>
    )
};
const EditableTextArea = ({ content, setContent }) => {
    const { t } = useTranslation(['detailContent', 'shared']);
    return (
        <TextareaAutosize
            className='bg-yellow border-0 no-scroll-bar outline-none'
            placeholder={t(NOTE_INPUT)}
            minRows={3}
            value={content}
            onInput={(e) => {
                setContent(e.currentTarget.value);
            }}
            style={{ resize: 'none' }}
            wrap='hard'
        />
    );
};

const DealContentForm = ({ id, contentText, setContent, children = [] }) => {
    return (
        <div key={id} className='mb-2'>
            <div className='input-group input-group-sm mb-1'>
                <div className='input-group-prepend' />
                {children.length === 0 ? (
                    <input
                        placeholder={contentText}
                        id={id}
                        type='text'
                        style={{ fontSize: '25px', fontWeight: 'bold' }}
                        className='form-control'
                        onInput={(e) => {
                            setContent(e.currentTarget.value);
                        }}
                    />
                ) : (
                    children
                )}
            </div>
        </div>
    );
};

/*
 * ==================================================================================
 *
 * FUNCTIONS
 *
 * ==================================================================================
 */


const GetActivityTitle = (activityType) => {
    const { t } = useTranslation(['detailContent', 'shared']);
    switch (activityType) {
        case 'BOM':
            return t(BOOKED_CUSTOMER, { ns: 'detailContent' });
        case 'COM':
            return t(COMPLETED_CUSTOMER_MEETING, { ns: 'detailContent' });
        case 'YIA':
            return t(YEARLY_INDEX_ADJUSTMENT, { ns: 'detailContent' });
        default:
            return '';
    }
};
